import React from 'react';
import { mockData } from '../mock';

export const WhatIsGrabo = () => {
  const { whatIsGrabo } = mockData;

  return (
    <section className="py-20 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Text Content */}
          <div className="space-y-5 md:space-y-6">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 tracking-tight">
              {whatIsGrabo.title}
            </h2>
            <p className="text-base md:text-lg text-gray-600 leading-relaxed">
              {whatIsGrabo.description}
            </p>
            <div className="pt-4">
              <div className="inline-block">
                <div className="text-3xl md:text-4xl font-bold text-[#2AD7C5] mb-2">Tap. Grab. Go.</div>
                <div className="h-1 bg-gradient-to-r from-[#2AD7C5] to-transparent rounded-full"></div>
              </div>
            </div>
          </div>

          {/* Image Placeholder */}
          <div className="relative">
            <div className="aspect-video rounded-2xl overflow-hidden shadow-2xl">
              <img
                src={whatIsGrabo.imagePlaceholder}
                alt="Grabo.ai Machine"
                className="w-full h-full object-cover"
              />
            </div>
            {/* Decorative Elements */}
            <div className="absolute -bottom-6 -left-6 w-32 h-32 bg-[#2AD7C5]/10 rounded-full blur-3xl"></div>
            <div className="absolute -top-6 -right-6 w-40 h-40 bg-[#2AD7C5]/10 rounded-full blur-3xl"></div>
          </div>
        </div>
      </div>
    </section>
  );
};
